namespace advisorop.components.advisor {


    class AccountSummaryController {
        $router;
        account: domains.IAccount;
        accountCopyBeforeInvestmentSwitch: domains.IAccount;
        tamps: domains.ITamp[] = [];
        selTamp: domains.ITamp;
        public billingTypeEnum = domains.FeeBillingType;

        boAccounts: Array<domains.IBOAccount> = [];
        repfeeGroups: Array<domains.IRepFeeGroup> = [];
        selRepfeeGroup: domains.IRepFeeGroup;
        ddlRepfeeGroup: domains.IRepFeeGroup;
        repGroupFeeOptions: domains.RepGroupFeeOptions;
        proposals: Array<domains.IProposal> = [];
        canRollbackProposal: boolean = false;
        openAreaForSign: boolean = false;
        switchingToManagedModels: boolean = false;
        switchingToIndividualHoldings: boolean = false;
        switchingInvestmentTypeStarted: boolean = false;
        allowAccountBeneficiariesChanges: boolean = false;

        selectedProposal: domains.IProposal = { investmentModels: [] };
        editProposal: domains.IProposal = { investmentModels: [] };
        custodian: domains.ICustodian;
        subAccounts: Array<domains.IAccount> =[]
        pricingType: string = "";
        parsedBilling: domains.IAdvancedBillingInfo = {};
        editRtg: boolean = false;
        flagDeletedHoldings: number;
        //########

        proposalState = domains.ProposalState;
        accountStatus = domains.AccountStatus;

        editingRepfeeGroup: boolean = false;
        repFeeGroupName: string = null;

        public dg: DevExpress.ui.dxDataGridOptions;
        noDataTextDefault = "There are no investment models";
        noDataTextOffModel = "Off Model";
        noDataText = "There are no investment models";

        public dgRepGroups: DevExpress.ui.dxDataGridOptions;
        public dgProposals: DevExpress.ui.dxDataGridOptions;
        public dgHouseholds: DevExpress.ui.dxDataGridOptions;
        public dgRtgs: DevExpress.ui.dxDataGridOptions;
        public dgAdvisoryDefinedGroups: DevExpress.ui.dxDataGridOptions;
        managedAccount: number;
        selPremiumMode: domains.ILOV;
        selUpdateFrequency: domains.ILOV;

        households: Array<domains.IHousehold> = [];
        rtgGroupsWhereAccountExist: Array<domains.IAccountGroup> = [];
        ADGroupsWhereAccountExist: Array<domains.IAccountGroup> = [];
        editRTGFlag = false;
        rtgId: number;
        directInvestment: number;
        managedModels: number;
        sma: number;
        outsideInvestment: number;
        individualHoldings: number;
        custodianAccount: number;
        openStatus: number = domains.AccountStatus.OPEN;
        closedStatus: number = domains.AccountStatus.CLOSED;
        canceledStatus: number = domains.AccountStatus.CANCELED;
        hasRtgHoldings: boolean = false;
        proposalCreateStatus: boolean = false;
        changeInvestmentTypeFromProposalTab: boolean = false;
        editingInvestments: boolean = false;
        accountId: number;
        custodianAccountId: number;
        laddaOperationInProgress: boolean = false;
        laddaOperationCloseReopenManualAccount: boolean = false;
        productTypeLifeInsurance: number;
        productTypeOtherInsurance: number;
        productTypeAnnuity: number;
        productTypeGeneralInvestment: number;
        hasInsuranceSubtypes: boolean = false;

        proposal: domains.IProposal;
        pricingTypes: Array<domains.ILOV> = []
        premiumModes: Array<domains.ILOV> = [];
        titleSubtypes: Array<domains.ILOV> = [];
        updateFrequencies: Array<domains.ILOV> = [];
        selTitleSubtype: domains.ILOV;
        lovs: Array<domains.ILOV> = [];

        user: domains.identity.IUser;

        //custodian and office range variables
        selCustodian: domains.ICustodianAdvisoryFirm;
        selOfficeRange: domains.ICustodianAdvisoryFirmOfficeRange;
        custodians: domains.ICustodianAdvisoryFirm[] = [];
        officeRanges: domains.ICustodianAdvisoryFirmOfficeRange[] = [];
        selPolicyType: domains.ILOV;
        selPolicySubtype: domains.ILOV;
        insuranceTypes: Array<domains.ILOV> = [];
        insuranceSubtypes: Array<domains.ILOV> = [];
        selGeneralInvestmentAccountType: domains.ILOV;
        generalInvestmentAccountTypes: Array<domains.ILOV> = [];

        selAdvisoryFirmMgtRole: domains.AdvisoryFirmMgtRole;

        preparingProposalExists: boolean = false;

        //tabs: number[] = [0,4,5,6,7];
        activeTab: number = 0;
        //activeTabIndex: number = 0;

        showAccountBeneficiariesDetails: boolean = false;
        accordionOptions: DevExpress.ui.dxAccordionOptions;

        aaEquityPct: number;
        aaFixedIncomePct: number;
        aaAltPct: number;
        aaCashPct: number;

        activeSecurityAllocationPlan: domains.IAFSecurityAllocationPlan = {};
        securityPlanLoaded = false;
        securityPlanExists = false;

        ctlOutsideHoldingList: advisorop.components.servicer.OutsideHoldingsListNewController;
        ctlAccountBeneficiaries: advisorop.components.advisor.SelectCuAccountBeneficiariesController;
        isInitializing: boolean = true;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#accountContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading account data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        };

        selAnnuityAccountStatus: domains.IAnnuityAccountStatusName = null;
        annuityAccountStatuses: Array<domains.IAnnuityAccountStatusName> = [
            { value: domains.AnnuityAccountStatus.ANNUITIZED, name: "Annuitized" },
            { value: domains.AnnuityAccountStatus.CANCELED, name: "Canceled" },
            { value: domains.AnnuityAccountStatus.CLOSED, name: "Closed" },
            { value: domains.AnnuityAccountStatus.DEATH_CLAIM_PAID, name: "Death Claim Paid" },
            { value: domains.AnnuityAccountStatus.FULLY_PAID_OUT, name: "Fully Paid Out" },
            { value: domains.AnnuityAccountStatus.OPEN, name: "Open" },
            { value: domains.AnnuityAccountStatus.RETURNED, name: "Returned" },
            { value: domains.AnnuityAccountStatus.SURRENDERED, name: "Surrendered" },
            { value: null, name: "Unknown" },
        ];
        isManualAccount: boolean = false;
        isNonPerformanceManualAccount: boolean = false;
        popupCloseDate: DevExpress.ui.dxPopupOptions;
        isPopupCloseDateVisible = false;
        accountCloseDate: Date = null;
        maxCloseDate: Date = new Date();

        static $inject = ["advisorService", "generalService", "accountGeneralService", "identityService", "advisoryFirmApi", "repGroupApi", "accountApi", "$rootScope"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            public accountGeneralService: services.AccountGeneralService,
            private identityService: services.IdentityService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private repGroupApi: services.RepGroupApi,
            private accountApi: services.AccountApi,
            private $rootScope: ng.IRootScopeService) {

            this.directInvestment = domains.InvestmentType.DIRECT_INVESTMENT;
            this.managedModels = domains.InvestmentType.MANAGED_MODELS;
            this.sma = domains.InvestmentType.SMA;
            this.outsideInvestment = domains.InvestmentType.OUTSIDE_INVESTMENT;
            this.individualHoldings = domains.InvestmentType.INDIVIDUAL_HOLDINGS;
            this.custodianAccount = domains.InvestmentType.CUSTODIAN_ACCOUNT;
            this.productTypeLifeInsurance = domains.ProductType.LIFE_INSURANCE;
            this.productTypeOtherInsurance = domains.ProductType.OTHER_INSURANCE;
            this.productTypeAnnuity = domains.ProductType.ANNUITY;
            this.productTypeGeneralInvestment = domains.ProductType.GENERAL_INVESTMENT;
            this.openStatus = domains.AccountStatus.OPEN;
            this.managedAccount = domains.AdvisoryFirmMgtRole.MANAGED;

            this.popupCloseDate = {
                deferRendering: false,
                width: 400,
                height: 300,
                showTitle: true,
                title: "Close Manual Account",
                dragEnabled: true,
                closeOnOutsideClick: false,
                showCloseButton: true,
                contentTemplate: 'content',
                bindingOptions: {
                    visible: "vm.isPopupCloseDateVisible",
                },
            };
            
            
            this.dgProposals = {
                export: {
                    enabled: true,
                    fileName: "Proposals"
                },
                bindingOptions: {
                    dataSource: "vm.proposals"
                },
                paging: {
                    pageSize: 5,
                    enabled: true
                },

                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "Proposals not found",

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    { dataField: "description", caption: "Proposal Description", cellTemplate: "colFullName" },
                    { dataField: "dateCreated", caption: "Date Created", dataType: "date", format: "shortDateShortTime" },
                    //{ dataField: "dateCompleted", caption: "Date Completed", dataType: "date", format: "shortDateShortTime"  },
                    { dataField: "dateChanged", caption: "Date Changed", dataType: "date", format: "shortDateShortTime" },
                    { dataField: "proposalState,", caption: "State", cellTemplate: "proposalState" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions" }
                ],
            };

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "InvestmentModels"
                },
                bindingOptions: {
                    dataSource: "vm.selectedProposal.investmentModels",
                    noDataText: "vm.noDataText"
                },
                //height: "350px",
                //width: "775px",
                paging: {
                    pageSize: 5,
                    enabled: true
                },
                //scrolling: {
                //    mode: "infinite"
                //},
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: "dgAccountsXY"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    { dataField: "managerName", caption: "Manager" },
                    { dataField: "productTypeName", caption: "Type" },
                    { dataField: "managerProductName", caption: "Product", cellTemplate: "colFullName" },
                    { dataField: "percentage", caption: "Allocation %", format: { type: "percent", precision: 2 }, visible: true, },
                    { dataField: "managerFeePercentage", caption: "Manager Fee %", format: { type: "percent", precision: 2 }, visible: true, }                ]
            };

            this.dgHouseholds = {
                export: {
                    enabled: true,
                    fileName: "HouseHolds"
                },
                bindingOptions: {
                    dataSource: "vm.households",

                },
                //height: "350px",

                paging: {
                    pageSize: 5,
                    enabled: true
                },

                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: true,
                allowColumnResizing: false,
                noDataText: "Households not found",

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    { dataField: "name", caption: "Name", cellTemplate: "colFullName" },
                    { dataField: "usdMarketValue", caption: "USD market value", format: { type: "currency" }, visible: false },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: 90, visible: false }
                ],

            };
            
            this.dgRtgs = {
                export: {
                    enabled: true,
                    fileName: "RTGWhereAccountsExist"
                },
                bindingOptions: {
                    dataSource: "vm.rtgGroupsWhereAccountExist",

                },
                //height: "350px",

                paging: {
                    pageSize: 5,
                    enabled: true
                },

                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: true,
                allowColumnResizing: false,
                noDataText: "Rtgs not found",

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    { dataField: "groupName", caption: "Group Name", cellTemplate: "colFullName" },
                    { dataField: "groupTypeDesc", caption: "Group Type", visible: false },
                    { dataField: "accountGroup.accountGroupDescription", caption: "Account Group Description" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions2", width: 90, visible: true }
                ],

            };

            this.dgRepGroups = {
                export: {
                    enabled: true,
                    fileName: "Allocations"
                },
                bindingOptions: {
                    dataSource: "vm.selRepfeeGroup.allocations",

                },
                //height: "350px",

                paging: {
                    pageSize: 5,
                    enabled: true
                },

                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: true,
                allowColumnResizing: false,
                noDataText: "Rep groups not found",

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    { dataField: "advisor.fullName", caption: "Advisor" },

                    { dataField: "percentage", caption: "Percentage", format: { type: "percent", precision: 2 } },

                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: 40, visible: false }
                ],

            };

            this.dgAdvisoryDefinedGroups = {
                export: {
                    enabled: true,
                    fileName: "ADGWhereAccountExist"
                },
                bindingOptions: {
                    dataSource: "vm.ADGroupsWhereAccountExist",

                },
                //height: "350px",

                paging: {
                    pageSize: 5,
                    enabled: true
                },

                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: true,
                allowColumnResizing: false,
                noDataText: "Advisory group not found",

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: false,
                columns: [
                    { dataField: "groupName", caption: "Group Name", cellTemplate: "colFullName" },
                    { dataField: "groupTypeDesc", caption: "Group Type", visible: false },
                    { dataField: "accountGroupDescription", caption: "Account Group Description" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: 90, visible: false }
                ],

            };
        }
        
        isLifeInsuranceTypeAccount(): boolean {
            return (this.account && this.account.productTypeId)
                && (this.account.productTypeId === domains.ProductType.LIFE_INSURANCE
                    || this.account.productTypeId === domains.ProductType.OTHER_INSURANCE);
        }

        // Can not change the account number of accounts that are linked to custodian accounts
        // or custodian accounts that are at Pershing (because Pershing pre-assigns account numbers)
        accountNumberUpdateAllowed(): boolean {
            if (this.account &&
                (this.account.custodianAccountId != null || this.account.custodianName == "Pershing"))
                return false;
            else
                return true;
        }

        productDescriptionUpdateAllowed(): boolean {
            return (this.account.accountType == domains.InvestmentType.CUSTODIAN_ACCOUNT
                || this.account.accountType == domains.InvestmentType.DIRECT_INVESTMENT)
        }

        titleSubtypeUpdateAllowed(): boolean {
            return (this.account.accountType != domains.InvestmentType.CUSTODIAN_ACCOUNT && this.account.custodianAccountId == null)
        }
        /*
        selectNextTab(): void {
            if (this.activeTabIndex >= this.tabs.length-1)
                this.activeTabIndex = 0;
            else 
                this.activeTabIndex++;
        
            this.activeTab = this.tabs[this.activeTabIndex];
         
            //console.log("Active tab: ", this.activeTab, this.activeTabIndex);
        }
        */

        refreshProposalDetails(proposalId: number): void {
            var tmpProps = this.proposals.filter((v, i, a) => { return v.id == proposalId });
            if (tmpProps.length > 0) {
                this.selectedProposal = tmpProps[0];

                this.noDataText = this.selectedProposal.isOffModel ? this.noDataTextOffModel : this.noDataTextDefault;

                var tmpCustodian = this.custodians.filter((v, i, a) => {
                    let id = this.selectedProposal.custodianAdvisoryFirmId;
                    return v.id == id;
                });
                if (tmpCustodian.length > 0) {
                    this.custodian = tmpCustodian[0];
                }

                if (this.selectedProposal.custodianPricingType != null) {
                    let tmpPricingType = this.pricingTypes.filter(v => v.id == this.selectedProposal.custodianPricingType);
                    if (tmpPricingType.length > 0) {
                        this.pricingType = tmpPricingType[0].name;
                    }
                }

                // Parse advanced billing info
                if (this.selectedProposal.advancedBillingInfo) {
                    try { this.parsedBilling = JSON.parse(this.selectedProposal.advancedBillingInfo); } catch (e) { this.parsedBilling = {}; }
                } else {
                    this.parsedBilling = {};
                }
            };
            //console.log("SELECTED", this.selectedProposal);
        };

        hasSelectedProposal(): boolean {
            return this.selectedProposal != null 
                && this.selectedProposal !== undefined
                && Object.keys(this.selectedProposal).length > 1
                && this.selectedProposal.id !== undefined;
        }

        changeState(): void {
            this.editRtg = !this.editRtg;
        }

        //syncAccountGroupsWithPp(householdId: number) {
        //    this.advisorService.syncAccountGroupsWithPp(householdId).then(data => {
        //        toastr.success("Household has been successfully syncronized");
        //    }, err => this.generalService.showError(err));
        //}

        syncAccountGroupsToBOSystem() {
            this.accountApi.syncAccountGroupsToBOSystem(this.account.id).then(data => {
                toastr.success("Account has been queued for Sync with the Back Office System.");
            }, err => this.generalService.showError(err));
        }

        loadHouseholdsWhereExistAccount(accountId: number): void {
            this.advisorService.getHouseholdsForAccount(accountId)
                .then(data => {
                    this.households = data.data;
                })
                .catch(err => {
                    toastr.error("Cannot fetch households");
                });
        };


        // ng-init in form tag for locating child form element. crazzy
        accountDetailsFormScope: any;
        setAccountDetailsFormScope(frmScope): void {
            this.accountDetailsFormScope = frmScope;
        }
        validateAccountDetailsForm(): boolean {
            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.accountDetailsFormScope["accountDetails"]);
            if (!formIsValid)
                toastr.error("Please correct errors and try again");
            return formIsValid;
        };

        canSwitchInvestmentType(): boolean {
            return this.switchingToManagedModels || this.switchingToIndividualHoldings || this.canSwitchToManagedModels() || this.canSwitchToIndividualHoldings();
        }

        canSwitchToManagedModels(): boolean {
            return (this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS && !this.switchingToIndividualHoldings) || this.switchingToManagedModels;
        }

        canSwitchToIndividualHoldings(): boolean {
            return (this.account.accountType == domains.InvestmentType.MANAGED_MODELS && !this.switchingToManagedModels) || this.switchingToIndividualHoldings;
        }

        cancelSwitchInvestmentType(): void {
            if (this.accountCopyBeforeInvestmentSwitch != undefined) {
                this.advisorService.updateAccount(this.accountCopyBeforeInvestmentSwitch).then(resp => {
                    this.account = resp.data;
                }).catch(reason => {
                    console.log(reason);
                }).finally(() => {
                    this.switchingInvestmentTypeStarted = false;
                    this.accountCopyBeforeInvestmentSwitch = undefined;
                })
            }
        }

        onSwitchInvestmentType(): void {
            var createNewProposal = false;
            this.accountCopyBeforeInvestmentSwitch = undefined;
            if (this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS || this.account.accountType == domains.InvestmentType.MANAGED_MODELS || this.account.accountType == domains.InvestmentType.SMA) {
                this.accountCopyBeforeInvestmentSwitch = angular.copy(this.account);
                this.switchingInvestmentTypeStarted = true;
                this.laddaOperationInProgress = true;
                this.switchingToManagedModels = this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS;
                this.switchingToIndividualHoldings = !this.switchingToManagedModels;
                this.account.accountType = this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS ? domains.InvestmentType.MANAGED_MODELS : domains.InvestmentType.INDIVIDUAL_HOLDINGS;
                this.account.tampId = this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS ? undefined : this.selTamp.id;
                this.advisorService.updateAccount(this.account).then(resp => {
                    this.account = resp.data;
                    createNewProposal = true;
                }).catch(reason => {
                    this.switchingInvestmentTypeStarted = false;
                    this.accountCopyBeforeInvestmentSwitch = undefined;
                    console.log(reason);
                }).finally(() => {
                    this.switchingToManagedModels = false;
                    this.switchingToIndividualHoldings = false;
                    this.laddaOperationInProgress = false;
                    this.changeInvestmentTypeFromProposalTab = false;
                    if (createNewProposal) {
                        this.activeTab = 3;
                        var props = this.proposals.filter(v => v.proposalState == domains.ProposalState.ACTIVE);
                        if (props.length > 0) {
                            // create a new proposal based on the new investment type
                            var newProposal = angular.copy(props[0]);
                            if (this.account.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS) {
                                newProposal.investmentModels = [];
                            } else {
                                newProposal.investmentDescription = undefined;
                            }
                            this.changeActiveProposal(newProposal);
                        }
                    }
                })
            }
        }

        changeInvestmentType(): void {
            this.changeInvestmentTypeFromProposalTab = !this.changeInvestmentTypeFromProposalTab;
        }

        annuityAccountStatusChanged(): void {
            this.account.manualAccount.annuityAccountStatus = this.selAnnuityAccountStatus.value;
        }

        closeManualAccount(): void {
            console.log('Opening close manual account popup...');
            this.accountCloseDate = new Date();
            this.maxCloseDate = new Date();
            this.isPopupCloseDateVisible = true;
        }

        cancelCloseDatePopup(): void {
            this.isPopupCloseDateVisible = false;
            this.accountCloseDate = null;
        }

        confirmCloseManualAccount(): void {
            console.log('Closing Manual account with date:', this.accountCloseDate);
            
            if (!this.accountCloseDate) {
                toastr.error("Please select a close date.");
                return;
            }

            if (this.accountCloseDate > new Date()) {
                toastr.error("Close date cannot be in the future.");
                return;
            }

            const utcCloseDate = new Date(Date.UTC(this.accountCloseDate.getFullYear(), this.accountCloseDate.getMonth(), this.accountCloseDate.getDate()));

            this.laddaOperationCloseReopenManualAccount = true;
            console.log('[AccountSummary] Calling closeManualAccount API for accountId:', this.account.id);
            this.advisorService.closeManualAccount(this.account.id, utcCloseDate)
                .then(data => {
                    console.log('[AccountSummary] Manual account closed successfully, account data:', data.data);
                    this.account = data.data;
                    this.isPopupCloseDateVisible = false;
                    this.accountCloseDate = null;
                    toastr.success("Account has been closed.");
                    
                    // Broadcast event to refresh outside holdings grid (backend sets amount to 0 on close)
                    console.log('[AccountSummary] Broadcasting outsideHoldingsRefresh event for accountId:', this.account.id);
                    this.$rootScope.$broadcast('outsideHoldingsRefresh', { accountId: this.account.id });
                })
                .catch(data => {
                    toastr.error("Account has not been closed! Error " + data.status + " " + data.data);
                })
                .finally(() => {
                    this.laddaOperationCloseReopenManualAccount = false;
                });
        }

        reopenManualAccount(): void {
            console.log('Reopening Manual account ...')
            var msg = "If you select this option, you will Open account again and you will be able to edit this account."
                + "\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";
            if (window.confirm(msg)) {
                this.laddaOperationCloseReopenManualAccount = true;
                this.advisorService.reopenManualAccount(this.account.id)
                    .then(data => {
                        this.account = data.data;
                        toastr.success("Account has been reopened.");
                    })
                    .catch(data => {
                        toastr.error("Account has not been reopened! Error " + data.status + " " + data.data);
                    })
                    .finally(() => {
                        this.laddaOperationCloseReopenManualAccount = false;
                    });
            }
        }

        updateAccountInformation(): void {

            if (!this.validateAccountDetailsForm())
                return;

            if (this.selPremiumMode)
                this.account.manualAccount.premiumMode = this.selPremiumMode.value;

            this.account.updateFrequency = null;
            if (this.selUpdateFrequency)
                this.account.updateFrequency = this.selUpdateFrequency.value;

            if (this.selRepfeeGroup)
                this.account.repFeeGroupId = this.selRepfeeGroup.id;

            if (this.account.manualAccount) {
                if (this.selGeneralInvestmentAccountType
                    && this.account.accountType == this.outsideInvestment
                    && this.account.productTypeId == this.productTypeGeneralInvestment) {
                    this.account.manualAccount.generalInvestmentAccountType = this.selGeneralInvestmentAccountType.value;
                }
                else {
                    this.account.manualAccount.generalInvestmentAccountType = null;
                }

                if (this.account.productTypeId == this.productTypeAnnuity
                    || this.account.productTypeId === this.productTypeLifeInsurance
                    || this.account.productTypeId === this.productTypeOtherInsurance) {
                    this.account.manualAccount.policyNumber = this.account.number.replace(/^\~/, '');
                }
            }

            if (this.selTitleSubtype != undefined) {
                this.account.titleSubtype = this.selTitleSubtype.value;
                this.account.titleSubtypeDescription = this.selTitleSubtype.name;
            }

            this.laddaOperationInProgress = true;
            this.advisorService.updateAccount(this.account)
                .then(response => {
                    toastr.success("Account succesfully updated");
                    this.loadAccount(response.data.id);
                    this.laddaOperationInProgress = false;
                }).catch(err => { this.generalService.showError(err); })
                .finally(() => { this.laddaOperationInProgress = false; });
        }

        //canBeOffModel(): boolean {
        //    var ret = this.account.accountType == domains.InvestmentType.MANAGED_MODELS;
                
        //    return ret;
        //}

        preparingProposal(): boolean {
            let ret = this.proposals.find(p => p.proposalState == domains.ProposalState.PREPARING) != undefined;
            return ret;
        }

        onCancelProposal(status: any): void {
            this.proposalCreateStatus = !status;
            if (this.switchingInvestmentTypeStarted == true) {
                this.cancelSwitchInvestmentType();
            }
        }

        editInvestments(proposal: domains.IProposal) {
            this.proposalCreateStatus = true;
            this.editingInvestments = true;
            this.editProposal = {};
            this.editProposal = angular.copy(proposal);
        }

        changeActiveProposal(proposal: domains.IProposal) {
            this.proposalCreateStatus = true;
            this.editingInvestments = false;
            this.editProposal = angular.copy(proposal);
        }

        cancelProposal(proposal: domains.IProposal) {
            this.advisorService.cancelProposal(proposal).then(response => {
                angular.copy(response.data, proposal);
            }, err => this.generalService.showError(err));
        }

        createOffModelProposal(proposal: domains.IProposal) {
            //console.log(proposal);
        }

        loadRTGsWhereExistAccount(accountId: number): void {
            var accountGroup: domains.IAccountGroup;
            this.advisorService.getAccountGroupsByAccountId(accountId)
                .then(data => {
                    this.rtgGroupsWhereAccountExist = data.data;
                    //console.log("RTGsGroups");
                    //console.log(this.rtgGroupsWhereAccountExist);
                })
                .catch(err => {
                    toastr.error("Unable to fetch rtg groups for this account.");
                });
        };


        loadADGroupsWhereExistAccount(accountId: number): void {
            this.advisorService.getAdvisoryDefinedGroupsByAccountId(accountId)
                .then(response => {
                    this.ADGroupsWhereAccountExist = response.data;

                    //console.log("AD GROUPS");
                    //console.log(this.ADGroupsWhereAccountExist);
                })
                .catch(err => {
                    toastr.error("Unable to fetch AD groups for this account.");
                });
        };
     
        onChangeHoldingsMaintainedExSystem(): void {
            
            if (this.account.holdingsMaintaindExSystem) {
                this.setExternalHoldings().then(response => {
                    toastr.success("Account info updated.");
                    this.deleteHoldingsForAccount().then(success => {
                        toastr.success("AdvisorOp holdings for this account have been deleted.");
                            this.flagDeletedHoldings = 1;
                    });
                });
            }
            else {
                this.setExternalHoldings().then(response => {
                    toastr.success("Account info updated.");
                    this.flagDeletedHoldings = 0;
                });
            }

            if (this.ctlOutsideHoldingList)
                this.ctlOutsideHoldingList.onChangeHoldingsMaintainedExSystem()
        };

        setExternalHoldings(): ng.IPromise<boolean> {
            return this.advisorService.setExternalHoldingsUpdate(this.account)
                .then(response => {
                    this.account = response.data;
                    return true;
                },
                    err => this.generalService.showError(err));
        };

        deleteHoldingsForAccount(): ng.IPromise<boolean> {
            return this.advisorService.deleteHoldingsAccount(this.account)
                .then(response => {
                    this.account = response.data;
                    return true;
                },
                    err => this.generalService.showError(err));
        };

        isOutsideHoldingsDisabled(): boolean {
            const status = this.account ? this.account.status : null;
            // AccountStatus.CLOSED = 11, AccountStatus.CANCELED = 10
            const closedOrCanceled = status === 11 || status === 10;
            console.log('[AccountSummary] isOutsideHoldingsDisabled -> status:', status, 'closedOrCanceled:', closedOrCanceled, 'flagDeletedHoldings:', this.flagDeletedHoldings);
            return closedOrCanceled || this.flagDeletedHoldings === 1;
        }

        generateProposalReport(accountId: number, proposalId: number) {
            this.advisorService.generateProposalReport(accountId, true, proposalId).then(data => {
               
                var file = new Blob([data.data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                var a = document.createElement("a");
                a.href = fileURL;
                window.open(a.href, '_blank');
            }).catch(error => {
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.data));
               // var obj = JSON.parse(decodedString);
               // var message = obj['message'];

                console.log("ERROR: ", decodedString);
                //this.generalService.showError(error)
                toastr.error(decodedString);
                });
        }; 

        loadAccount(accountId: number) {
            this.accountApi.getById(accountId)
                .then((data) => {
                    this.account = data.data;
                    //console.log("Account data: ");
                    //console.log(this.account);
                    this.accountId = this.account.id;
                    this.isManualAccount = this.account.number.startsWith("~");
                    this.isNonPerformanceManualAccount = this.isManualAccount && !this.account.holdingsMaintaindExSystem;
                    if (this.accountId > 0) {
                        this.accountApi.getBoAccounts(this.accountId)
                            .then((data) => {
                                this.boAccounts = data.data;
                            })
                            .catch((reason) => {
                                console.log(reason.statut + ' ' + reason.data);
                            })
                        this.securityPlanExists = false;
                        this.accountApi.getActiveSecurityAllocationPlan(this.accountId)
                            .then((data) => {
                                this.activeSecurityAllocationPlan = data.data;
                                if (this.activeSecurityAllocationPlan) {
                                    this.securityPlanExists = true;
                                }
                                this.securityPlanLoaded = true;
                            })
                            .catch((reason) => {
                                console.log(reason.statut + ' ' + reason.data);
                            })
                    }
                    this.custodianAccountId = this.account.custodianAccountId;
                    this.subAccounts = this.account.custodianSubAccounts;
                
                    if (this.account.repFeeGroup)
                        this.repFeeGroupName = this.account.repFeeGroup.name;
                    else
                        this.repFeeGroupName = null;

                    if (this.account.manualAccount)
                        this.selPremiumMode = this.premiumModes.filter(w => w.value == this.account.manualAccount.premiumMode)[0];

                    this.selUpdateFrequency = { value: this.account.updateFrequency };

                    if (this.account.fees) {
                        this.repGroupFeeOptions = domains.RepGroupFeeOptions.WITH_FEES;
                    }
                    else {
                        this.repGroupFeeOptions = domains.RepGroupFeeOptions.NO_FEES;
                    }

                    this.titleSubtypes = this.titleSubtypes.filter(v => v.parentId == this.account.titleType);
                    this.selTitleSubtype = this.titleSubtypes.filter(v => v.value == this.account.titleSubtype)[0];

                    if (this.account.repFeeGroupId > 0)
                        this.loadRepFeeGroup(this.account.repFeeGroupId);
                    else
                        this.ddlRepfeeGroup = null;

                    this.getRepFeeGroupsForAccount();
                    this.loadProposalsForAccount(this.account.titleId);
                    this.loadHouseholdsWhereExistAccount(this.account.id);
                    this.loadRTGsWhereExistAccount(this.account.id);
                    this.loadADGroupsWhereExistAccount(this.account.id);
                    this.loadTamps(this.account.advisoryFirmId);

                    this.loadCustodians(this.account.advisoryFirmId)
                        .then(data => this.selectCustodian());

                    this.loadInsuranceTypes();
                    this.selPolicyType = this.insuranceTypes.filter(v => v.value == this.account.manualAccount.policyInsuranceType)[0];
                    this.loadInsuranceSubtypes();
                    this.selPolicySubtype = this.insuranceSubtypes.filter(v => v.value == this.account.manualAccount.policyInsuranceSubtype)[0];

                    if (this.account.accountType == this.outsideInvestment
                        && this.account.productTypeId == this.productTypeGeneralInvestment) {
                        this.selGeneralInvestmentAccountType = this.generalInvestmentAccountTypes.filter(v => v.value == this.account.manualAccount.generalInvestmentAccountType)[0];
                    }

                    this.selAdvisoryFirmMgtRole = this.account.advisoryFirmMgtRole;

                    if (this.account.manualAccount) {
                        this.selAnnuityAccountStatus = this.annuityAccountStatuses.filter(v => v.value == this.account.manualAccount.annuityAccountStatus)[0];
                    }

                    this.isInitializing = false;
                })
                .catch((data) => {
                    toastr.error("Error " + data.status + " " + data.data);
                });
        };

        loadRepFeeGroup(groupId: number) {
            this.repGroupApi.getById(groupId)
                .then(response => {
                    this.selRepfeeGroup = response.data;
                    this.ddlRepfeeGroup = {};
                    angular.copy(response.data, this.ddlRepfeeGroup);
                }, err => this.generalService.showError(err));
        };

        loadTamps(advisoryFirmId: number): ng.IPromise<domains.ITamp[]> {
            //console.log("NewCuAccount loading tamps...");
            return this.advisoryFirmApi.getTamps(advisoryFirmId)
                .then(response => {
                    this.tamps = response.data;
                    // by default first TAMP is selected - PERSHING
                    if (!this.selTamp && this.tamps.length > 0) {
                        this.selTamp = this.tamps[0];

                        if (this.account.tampId != undefined) {
                            this.selTamp = this.tamps.filter(t => t.id == this.account.tampId)[0];
                        } 
                    }
                    return response.data;
                }, err => this.generalService.showError(err));
        };

        cancelRepFeeGroupEditing()
        {
            this.editingRepfeeGroup = false;
            if (this.selRepfeeGroup)
            {
                this.ddlRepfeeGroup = {};
                angular.copy(this.selRepfeeGroup, this.ddlRepfeeGroup);
            } else {
                this.ddlRepfeeGroup = null;
            }
        }

        repfeeGroupSelected(repfeeGroup: domains.IRepFeeGroup): void {
            //console.log("accountSummary.repfeeGroupSelected fired", repfeeGroup);
            if (repfeeGroup)
                this.account.repFeeGroupId = repfeeGroup.id;
            else
                this.account.repFeeGroupId = null;
        };

        assignRepFeeGroupToAccount(): void {
            if (!this.ddlRepfeeGroup || !this.ddlRepfeeGroup.id) {
                toastr.error("Please select Group");
                return;
            }
            //console.log("DDL REP GROUP", this.ddlRepfeeGroup);

            this.advisorService.updateAccountsRepFeeGroup(this.account)
                .then(response => {
                    this.editingRepfeeGroup = false;
                    this.selRepfeeGroup = this.ddlRepfeeGroup;
                    toastr.success("Rep Group has been successfully updated.");
                }, err => toastr.error("ERROR: " + err.status + " " + err.data));
        };

        loadProposalsForAccount(titleId: number): void {
            this.advisorService.getProposalsByTitle(titleId)
                .then(data => {
                    this.proposals = data.data;
                    var props: Array<domains.IProposal> = this.proposals.filter(v => v.proposalState == domains.ProposalState.PREPARING);
                    if (props.length > 0) {
                        //console.log("FOUND PROPS IN PENDING", props);
                        this.preparingProposalExists = true
                        this.canRollbackProposal = false;
                    }
                    else {
                        this.preparingProposalExists = false
                        props = this.proposals.filter(v => v.proposalState == domains.ProposalState.ACTIVE);
                        if (props.length > 0) {
                            this.canRollbackProposal = props[0].previousActiveProposal != null;
                        }
                    }

                    // Refresh proposal details (including parsedBilling) for the current proposal
                    if (props.length > 0) {
                        this.refreshProposalDetails(props[0].id);
                    }

                    // this.currentInvestmentsOfSelectedProposal = this.proposals[0].investmentModels;
                })
                .catch(err => {
                    toastr.error("Unable to fetch proposals for this account.");
                });
        };

        rollbackProposal(): void {
            var currentActiveProposal = this.proposals.filter(p => p.proposalState == domains.ProposalState.ACTIVE);

            if (currentActiveProposal.length > 0) {
                if (window.confirm(`Are you sure you want to rollback proposal "${currentActiveProposal[0].description}"?`)) {
                    this.advisorService.rollbackProposal(currentActiveProposal[0].id, currentActiveProposal[0].previousActiveProposal)
                        .then(data => {
                            toastr.success("Rollbacked to \"" + data.data.description + "\" proposal.");
                            this.loadProposalsForAccount(this.account.titleId);
                        })
                        .catch(err => {
                            toastr.error("Failed to rollback proposal.")
                        })
                }
            }
        }

        loadProposalById(proposalId: number): void {
            this.advisorService.getProposal(proposalId)
                .then(data => {
                    this.proposal = data.data;
                })
                .catch(err => {
                    toastr.error("Cannot fetch proposal!");
                });
        };

        proposalCreated(proposal: domains.IProposal): void {
            this.selectedProposal = { investmentModels: [] };
            this.account.proposal = proposal;
            // refreshing proposals
            this.loadProposalsForAccount(this.account.titleId);
            this.editProposal = {};
            this.proposalCreateStatus = false; // this will hide proposal editing form
            this.switchingInvestmentTypeStarted = false;
            this.accountCopyBeforeInvestmentSwitch = undefined;
            // editInvestments will load the preparing proposal so it can be signed.
            this.editInvestments(this.account.proposal);
        };

        proposalSigned(proposal: domains.IProposal): void {
            this.editProposal = {};
            // no need for this any more. proposal will be activated automatically. signed = acitve
            //this.advisorService.activateProposal(proposal).then(data => {
            toastr.success("Proposal has been activated");
            this.loadProposalsForAccount(this.account.titleId);
            this.proposalCreateStatus = false; // this will hide proposal editing form
            this.refreshProposalDetails(this.account.proposal.id);
            //}, err => this.generalService.showError(err));
        };

        loadInsuranceTypes(): void {
            if (this.account && this.account.productTypeId) this.insuranceTypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_TYPE && v.parentId == this.account.productTypeId);
            else this.insuranceTypes = [];
        };

        loadInsuranceSubtypes(): void {
            if (this.account && this.account.productTypeId && this.selPolicyType) this.insuranceSubtypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_SUBTYPE && v.parentId == this.selPolicyType.value);
            else this.insuranceSubtypes = [];
        };

        updateAccount(account: domains.IAccount): ng.IPromise<void> {
            return this.advisorService.updateAccount(this.account)
                .then(response => {
                        toastr.success("Account has been successfully updated.");
                        this.account = response.data;
                }, err => this.generalService.showError(err));
        }

        getRepFeeGroupsForAccount(): void {

            this.repGroupApi.getForAccount(this.account.id)
                .then(data => {
                    this.repfeeGroups = data.data;
                }, err => this.generalService.showError(err));
        }

        selectCustodian() {
            this.selCustodian = null;
            this.officeRanges = null;
            if (this.custodians && this.custodians.length > 0) {
                var cust = this.custodians.filter((v) => { return v.custodianId == this.account.custodianId; });
                if (cust.length <= 0) return;
                this.selCustodian = cust[0];
                if (this.selCustodian.custodian.hasOfficeRanges) {
                    this.officeRanges = this.selCustodian.officeRanges;
                    if (this.account.officeRangeId <= 0) return;
                    var sor = this.officeRanges.filter((v) => { return v.id == this.account.officeRangeId; });
                    if (sor.length > 0)
                        this.selOfficeRange = sor[0];
                }
            }
        }

        custodianChanged(): void {
            if (this.selCustodian && this.selCustodian.custodian.hasOfficeRanges)
                this.officeRanges = this.selCustodian.officeRanges;
            else
                this.officeRanges = [];
        }
        
        policyTypeChanged(): void {
            this.loadInsuranceSubtypes();
            if (this.selPolicyType) {
                this.account.manualAccount.policyInsuranceType = this.selPolicyType.value;
                if (this.insuranceSubtypes.length > 0) {
                    this.hasInsuranceSubtypes = true;
                    this.selPolicySubtype = this.insuranceSubtypes[0];
                }
                else
                    this.selPolicySubtype = null;
            }
            else {
                this.selPolicySubtype = null;
            }
            this.policySubtypeChanged();
        };

        policySubtypeChanged(): void {
            if (this.selPolicySubtype) {
                this.account.manualAccount.policyInsuranceSubtype = this.selPolicySubtype.value;
            }
        }

        advisoryFirmMgtRoleChanged(): void {
            if (this.selAdvisoryFirmMgtRole) {
                this.account.advisoryFirmMgtRole = this.selAdvisoryFirmMgtRole;
            }
        }

        loadCustodians(advisoryFirmId: number): ng.IPromise<void> {
            return this.advisorService.getCustodiansForAdvisoryFirm(advisoryFirmId)
                .then(data => {
                    this.custodians = data.data;
                }, err => this.generalService.showError(err));
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;
                    this.premiumModes = this.lovs.filter(v => v.lovType == domains.LovType.PREMIUM_MODE);
                    this.updateFrequencies = this.lovs.filter(v => v.lovType == domains.LovType.UPDATE_FREQUENCY);
                    this.generalInvestmentAccountTypes = this.lovs.filter(v => v.lovType == domains.LovType.GENERAL_INVESTMENT_ACCOUNT_TYPES);
                    this.titleSubtypes = this.lovs.filter(v => v.lovType == domains.LovType.TITLE_SUBTYPE);
                    this.pricingTypes = this.lovs.filter(v => v.lovType == domains.LovType.PRICING_TYPE);
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        refreshOutsideHoldingsGrid(): void {
            //console.log("Refreshing grid...");
            if (this.account && !this.account.holdingsMaintaindExSystem)
                $("#dgOutsideHoldings").dxDataGrid("instance").refresh();
        }

        // outside holdings
        onHoldingsRtgChanged(hasRtgHoldings: any) {
            //console.log("Has holdings:", hasRtgHoldings);
            this.hasRtgHoldings = hasRtgHoldings;
        }

        isInsuranceAccount(): boolean {
            return this.account.productTypeId && (this.account.productTypeId == domains.ProductType.LIFE_INSURANCE ||
                this.account.productTypeId == domains.ProductType.OTHER_INSURANCE);
        }

        isBrokerDealerFirm(): boolean {
            return this.account.advisoryFirm.firmType == domains.FirmType.BROKER_DEALER;
        }

        showAccountBeneficiaries() {
            return this.account != undefined && this.account.titleType != undefined && (this.account.titleType == domains.TitleType._529_PLAN_ACCOUNT || this.account.titleType == domains.TitleType.IRA
                || this.account.titleType == domains.TitleType.INDIVIDUAL_TRANSFER_ON_DEATH || this.account.titleType == domains.TitleType.JOINT_TRANSFER_ON_DEATH);
        }

        bindOutsideHoldingList = (ctrl) => {
            this.ctlOutsideHoldingList = ctrl;
        }

        bindAccountBeneficiaries = (ctrl) => {
            this.ctlAccountBeneficiaries = ctrl;
        }

        swapAllowAccountBeneficiariesChanges = () => {
            console.log("Cancel Beneficiaries changed");
            if (this.allowAccountBeneficiariesChanges) {
                this.ctlAccountBeneficiaries.loadAccountBeneficiaries();
            }
            this.allowAccountBeneficiariesChanges = !this.allowAccountBeneficiariesChanges;
        }

        $onInit(): void {
            this.loadLovs();
            
            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });

            this.accordionOptions = {
                //dataSource: accordionItems,
                //itemTemplate: "customer",
                bindingOptions: {
                    animationDuration: 300,
                    collapsible: true,
                    multiple: false
                }
            };
        }

        openRtqReport(rtg: domains.IAccountGroup) {
            //console.log(`Opening: api/advisor/getrtqreport/${this.account.id}/${rtg.id}/0`);
            window.open(`api/advisor/getrtqreport/${this.account.id}/${rtg.id}/0`, `_blank`);
        }

        $routerOnActivate(next, previous) {
            // navigation parameter
            if (next.params['NP'])
                this.activeTab = <number>next.params['NP'];
            //console.log("Active tab: ", this.activeTab);
            this.loadAccount(<number>next.params.accountId);
        }
    }


    class AccountSummary implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = AccountSummaryController;
            this.controllerAs = "vm";
            this.bindings = {
                $router: "<",
            };
            this.templateUrl = "spa/advisor-module/views/account-summary.html";
        }
    }
    angular.module(Constants.APP).component("accountSummary", new AccountSummary());
}